<template>
  <div class="profile">
    <!-- 个人中心主容器 -->
    <div class="user-center-wrap">
      <!-- 侧边栏页签 -->
      <UserSidebar @tabChange="handleTabChange" :activeTab="activeTab" />
      <!-- 主内容区 -->
      <div class="main-content">
        <UserInfo
            v-if="activeTab === 'info'"
            :userInfo="userInfo"
            @updateUserInfo="updateUserInfo"
        />
        <SecurityCenter
            v-if="activeTab === 'security'"
            @passwordUpdated="handlePasswordUpdated"
        />
        <MyComments
            v-if="activeTab === 'myComments'"
        />
        <MyDownloadCodes
            v-if="activeTab === 'myDownloadCodes'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import newService from "@/api/newService";
import config from "@/config";
import UserSidebar from './UserSidebar.vue';
import UserInfo from './UserInfo.vue';
import SecurityCenter from './SecurityCenter.vue';
import MyComments from './MyComments.vue';
import MyDownloadCodes from "@/components/mian/personProfile/MyDownloadCodes.vue";

export default {
  name: "UserCenter",
  components: {
    MyDownloadCodes,
    UserSidebar,
    UserInfo,
    SecurityCenter,
    MyComments
  },
  data() {
    return {
      activeTab: "info", // 默认选中个人信息页签
      userInfo: {
        loginName: "",
        name: "",
        email: "",
        phone: ""
      }
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // 获取用户信息
    getInfo() {
      const userId = this?.$TOOL?.data?.get('USER_INFO').id;
      newService.getUserById(userId).then(res => {
        this.userInfo = res;
      }).catch(err => {
        console.log(err)
      })
    },

    // 处理页签切换
    handleTabChange(tabIndex) {
      this.activeTab = tabIndex;
    },

    // 更新用户信息
    updateUserInfo(updatedInfo) {
      this.userInfo = { ...this.userInfo, ...updatedInfo };
    },

    // 处理密码更新后的操作
    handlePasswordUpdated() {
      this.logout();
      this.$message({
        type: "success",
        message: "密码修改成功！"
      });
    },

    // 退出登录
    logout() {
      // 清除登录相关数据
      this.$cookies.remove(config.TOKEN);
      this.$TOOL.data.remove(config.TOKEN);
      this.$TOOL.data.remove("USER_INFO");
      this.$TOOL.data.remove("IS_PRIMARY_TENANT");
      this.$store.commit("user/updateUser", null);
      this.$TOOL.data.remove("TODO_VAL");
      this.$router.push('/login');
    }
  }
};
</script>

<style lang="scss" scoped>
.profile {
  padding-top: 5rem;
  background: url('../../../assets/about/about7bg.png') no-repeat;
  background-size: cover;
  min-height: 100vh;
}

// 个人中心主容器
.user-center-wrap {
  width: 120rem;
  min-width: 120rem;
  padding: 5rem 0;
  margin: 0 auto;
  display: flex;
  gap: 4rem;
}

// 主内容区样式
.main-content {
  flex: 1;
}

// 适配Element UI组件样式穿透
::v-deep .el-card {
  background-color: transparent;
}

::v-deep .el-message {
  font-size: 1.6rem;
}
</style>
